module.exports = __webpack_public_path__ + "img/Slide7.108fa4ad.png";